<template>
  <aside>
    <h1>Wykryj Klauzule Abuzywne Online</h1>

    <p>Wykorzystaj sztuczną inteligencję do wykrywania niedozwolonych zapisów w umowach bankowych.</p>
  </aside>
</template>

<script>
export default {
  name: 'Promo'
}
</script>

<style scoped>
  aside {
    padding: 10vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  aside > h1 {
    color: white;
    font-size: 5em;
    text-transform: uppercase;
    letter-spacing: 2px;
  }

  aside > p {
    color: white;
    font-size: 2em;
  }
</style>
